import { ref, Ref } from "vue"
import ResponsesCache, { IResponsesCache } from "@/vue/planning/classes/ResponsesCache"

const responsesCache: Ref<IResponsesCache> = ref(new ResponsesCache())

export default responsesCache